module.exports = require('./methods')



//////////////////
// WEBPACK FOOTER
// ./~/_xe-utils@2.8.3@xe-utils/index.js
// module id = 671
// module chunks = 106